import { motion } from "framer-motion";

const MATERIALS = [
  { name: "Timber", img: "/timber_boston_oak.jpg", desc: "Deep, rich oak and walnut grain — engineered and solid boards selected for warmth and longevity." },
  { name: "Carpet", img: "/carpet.jpg", desc: "Tactile, plush woven structures — wool and hybrid constructions that soften acoustics and step." },
  { name: "Tile", img: "/tile_botticino.jpg", desc: "Precision-engineered ceramic and porcelain — large-format finishes with faultless, considered lines." },
  { name: "Stone", img: "/stone_taj_mahal.jpg", desc: "Raw, textured natural mineral surfaces — honed limestone, marble and travertine with quiet gravity." },
];

export default function Deconstruction() {
  return (
    <section className="relative bg-[#121315] pb-32 md:pb-48 cv-auto">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="border-t border-[#8C7355]/20 pt-16 md:pt-24">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
            <h2 className="font-serif-display text-[#F5F4F0] font-light tracking-tight text-4xl sm:text-5xl md:text-6xl max-w-xl leading-[1.02]">
              The four<br />elements
            </h2>
            <p className="text-[#D6D1CA]/75 text-sm max-w-xs font-body">Each quadrant of the puzzle is an element unto itself — mastered, sourced and curated in one studio.</p>
          </div>

          <div className="divide-y divide-[#8C7355]/15 border-t border-b border-[#8C7355]/15">
            {MATERIALS.map((m, i) => (
              <motion.div
                key={m.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                className="group grid grid-cols-12 gap-4 items-center py-8 md:py-10"
              >
                <div className="col-span-3 md:col-span-2">
                  <div className="relative w-16 h-16 md:w-24 md:h-24 overflow-hidden rounded-sm border border-[#8C7355]/25">
                    <img src={m.img} alt={`${m.name} material`} loading="lazy"
                      className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
                  </div>
                </div>
                <h3 className="col-span-9 md:col-span-4 font-serif-display text-[#F5F4F0] text-2xl sm:text-3xl md:text-4xl font-light tracking-tight group-hover:text-[#C9A876]" style={{ transition: "color 0.4s ease" }}>
                  {m.name}
                </h3>
                <p className="col-span-12 md:col-span-6 text-[#D6D1CA]/75 text-sm md:text-base font-body md:pl-8">{m.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
